import React from "react";
import { Link } from "react-router-dom";
import "./NotFoundPage.css";

/**
 * Catch-all for unmatched routes. Without this, React Router matched nothing and
 * (combined with the SPA index.html fallback) any typo'd URL rendered a blank page.
 */
export default function NotFoundPage() {
  return (
    <section className="notfound-root">
      <p className="notfound-code">404</p>
      <h1 className="notfound-title">Page not found</h1>
      <p className="notfound-text">
        The page you’re looking for doesn’t exist or may have moved.
      </p>
      <Link className="notfound-link" to="/">
        Back to gallery
      </Link>
    </section>
  );
}
